export default "__VITE_ASSET__FhljXGHJ__"